<template>

  <section class="bulk-delete-result">

    <div class="bulk-delete-result__summary">

      <div class="bulk-delete-result__metric bulk-delete-result__metric--success">
         <span>Thành công</span> <strong>{{ result.succeeded.length }}</strong
        >
      </div>

      <div class="bulk-delete-result__metric bulk-delete-result__metric--danger">
         <span>Thất bại</span> <strong>{{ result.failed.length }}</strong
        >
      </div>

    </div>

     <b-table
      v-if="result.failed.length > 0"
      :items="result.failed"
      :fields="failedFields"
      small
      bordered
      responsive
      class="bulk-delete-table"
      > <template #cell(saleInvoiceCode)="{ item }"
        >
        <div class="bulk-delete-result__invoice-cell">
           <strong>{{ item.saleInvoiceCode || item.salesInvoiceId }}</strong
          >
        </div>
         </template
      > <template #cell(errorMessage)="{ item }"
        >{{ item.error ? item.error.message : 'Lỗi không xác định' }}</template
      > </b-table
    >

  </section>

</template>

<script>
  export default {
    name: 'BulkDeleteResultState',
    props: {
      result: {
        type: Object,
        default: () => ({ succeeded: [], failed: [] }),
      },
    },
    computed: {
      failedFields() {
        return [
          { key: 'saleInvoiceCode', label: 'Số HĐ nguồn' },
          { key: 'errorMessage', label: 'Lỗi' },
        ]
      },
    },
  }
</script>

<style scoped>
  .bulk-delete-result {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
  }

  .bulk-delete-result__summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .bulk-delete-result__metric {
    padding: 0.8rem 0.9rem;
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
  }

  .bulk-delete-result__metric--success {
    background: #f3fbf7;
    border-color: #cfe9db;
  }

  .bulk-delete-result__metric--danger {
    background: #fff6f7;
    border-color: #efc7cd;
  }

  .bulk-delete-result__metric span {
    display: block;
    color: #748093;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .bulk-delete-result__metric strong {
    display: block;
    margin-top: 0.2rem;
    color: #1f2a3d;
    font-size: 1.05rem;
    font-weight: 700;
  }

  .bulk-delete-table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-delete-table table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-delete-table thead th {
    background: #f7f9fc;
    color: #445166;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .bulk-delete-result__invoice-cell {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-delete-result__invoice-cell strong {
    color: #1f2a3d;
    font-size: 0.9rem;
    font-weight: 700;
  }

  @media (max-width: 575.98px) {
    .bulk-delete-result__summary {
      grid-template-columns: 1fr;
    }
  }
</style>
